<template>
  <div
    class="hidden w-full lg:block flex-grow lg:flex lg:items-center lg:w-auto"
  >
    <div class="viewport-selectors lg:flex-grow">
      <button
        class="viewport-selector"
        :class="phone"
        @click="onViewportSelected('phone')"
      >
        <v-icon class="viewport-selector-icon" name="mobile-alt" scale="1.5" />
      </button>
      <button
        class="viewport-selector"
        :class="tablet"
        @click="onViewportSelected('tablet')"
      >
        <v-icon class="viewport-selector-icon" name="tablet-alt" scale="1.5" />
      </button>
      <button
        class="viewport-selector"
        :class="desktop"
        @click="onViewportSelected('desktop')"
      >
        <v-icon class="viewport-selector-icon" name="desktop" scale="1.5" />
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from "@/lib/event-bus.js";

export default {
  name: "ViewportSelector",
  data() {
    return {
      previewDevice: "desktop"
    };
  },
  computed: {
    phone() {
      return {
        active: this.previewDevice === "phone"
      };
    },
    tablet() {
      return {
        active: this.previewDevice === "tablet"
      };
    },
    desktop() {
      return {
        active: this.previewDevice === "desktop"
      };
    }
  },
  methods: {
    onViewportSelected(device) {
      this.previewDevice = device;

      EventBus.$emit("viewport-selected", device);
    }
  }
};
</script>

<style scoped>
.viewport-selectors {
  @apply text-center text-sm;
}

.viewport-selector {
  @apply mt-4 mx-3 text-grey-light inline-block mt-0 rounded-lg outline-none;
  line-height: 1;
  height: 45px;

  &:hover {
    @apply text-success;
  }

  &.active {
    @apply bg-brand text-white;
  }
}

.viewport-selector-icon {
  @apply relative;
  top: 1px;
}
</style>
